
define('text!views/shared/grid/grid.html',[],function () { return '<h2 class="textCenter space-15"><%- this.grid.header %></h2>\r\n\r\n<ul class="<%- this.grid.list_class %>"></ul>';});

